import { PERSONAL_TOKENS } from '@elementary/common-ui/constants/queryKeys';
import { TokenConfig, TokenApi } from '../shared/types';
import TokensPage from '../shared/TokensPage';
import * as api from './services/api';

const PersonalTokens = () => {
  const tokenApi: TokenApi = {
    getTokens: api.getPersonalTokens,
    createToken: api.createPersonalToken,
    deleteToken: api.deletePersonalToken,
  };

  const config: TokenConfig = {
    queryKey: [PERSONAL_TOKENS],
    api: tokenApi,
    tokenType: 'personal',
    successMessages: {
      create: 'Personal token created successfully',
      delete: 'Personal token deleted successfully',
      createError: 'Failed to create personal token',
      deleteError: 'Failed to delete personal token',
    },
  };

  return (
    <TokensPage
      config={config}
      breadcrumbs={['User', 'Personal Tokens']}
      pageTitle="User tokens"
      urlParamsPrefix="tokens_table"
    />
  );
};

export default PersonalTokens;
